module.exports = " <div class=\"content\"> <div class=\"col-md-12\"> <h1 class=\"title\"> {{'shared.errorMessage.404NotFound' | translate}} </h1> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/pages/not-found-404-page.cmp.html
// module id = 864
// module chunks = 1